import React, { useState } from 'react'

import Desktop from './desktop'
import Mobile from './mobile'

export default () => {
  const [isMobile, setIsMobile] = useState(window.outerWidth < 1024)

  React.useEffect(() => {
    window.addEventListener('resize', () => {
      setIsMobile(window.outerWidth < 1024)
    })
  }, [])

  return (
    isMobile ? (
      <Mobile />
    ) : (
      <Desktop />
    )
  )
}
